import { useState, useEffect } from 'react';
import { getDeviceType, type DeviceType } from '@/shared/constants/breakpoints';

/**
 * レスポンシブフック用定数
 */
const RESPONSIVE_HOOK_CONSTANTS = {
  /** デフォルトウィンドウ幅（SSR対応） */
  DEFAULT_WINDOW_WIDTH: 1024,
  /** リサイズイベントのデバウンス時間（ミリ秒） */
  DEBOUNCE_DELAY_MS: 150,
} as const;

/**
 * レスポンシブデザイン用カスタムフック
 * ウィンドウサイズを監視してデバイスタイプを返す
 */
export const useResponsive = () => {
  const [windowWidth, setWindowWidth] = useState<number>(
    typeof window !== 'undefined' ? window.innerWidth : RESPONSIVE_HOOK_CONSTANTS.DEFAULT_WINDOW_WIDTH
  );
  const [deviceType, setDeviceType] = useState<DeviceType>(
    getDeviceType(windowWidth)
  );

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      setWindowWidth(newWidth);
      setDeviceType(getDeviceType(newWidth));
    };

    // デバウンス処理
    let timeoutId: number;
    const debouncedResize = () => {
      clearTimeout(timeoutId);
      timeoutId = window.setTimeout(handleResize, RESPONSIVE_HOOK_CONSTANTS.DEBOUNCE_DELAY_MS);
    };

    window.addEventListener('resize', debouncedResize);

    // 初回実行
    handleResize();

    return () => {
      window.removeEventListener('resize', debouncedResize);
      clearTimeout(timeoutId);
    };
  }, []);

  return {
    windowWidth,
    deviceType,
    isMobile: deviceType === 'mobile',
    isDesktop: deviceType === 'desktop',
  };
};